// @flow
// ### AUTOMATICALLY GENERATED FILE. Remove this comment to preserve your edits in the file. ###
import { safeCombineReducers } from 'metaup/redux/reduxUtils';
// ### GENERATED IMPORTS GO HERE ###

export const namespace = 'elements';

export const reducer = safeCombineReducers({
  // ### GENERATED REDUCERS GO HERE ###
});
